const Talimat = resolve => {
    require.ensure(['../views/apps/talimat/Talimat'], () => {
        resolve(require('../views/apps/talimat/Talimat'));
    });
};
const TalimatTanimla = resolve => {
    require.ensure(['../views/apps/talimat/TalimatTanimla'], () => {
        resolve(require('../views/apps/talimat/TalimatTanimla'));
    });
};
const TalimatListesi = resolve => {
    require.ensure(['../views/apps/talimat/TalimatListesi'], () => {
        resolve(require('../views/apps/talimat/TalimatListesi'));
    });
};
const TalimatGuncelle = resolve => {
    require.ensure(['../views/apps/talimat/TalimatGuncelle'], () => {
        resolve(require('../views/apps/talimat/TalimatGuncelle'));
    });
};

import layouts from '../layout';
import Vue from 'vue';
Vue.component('talimattanimla', TalimatTanimla);
Vue.component('talimatlistesi', TalimatListesi);
Vue.component('talimatguncelle', TalimatGuncelle);

export default {
    path: '/talimat',
    name: 'talimat',
    component: Talimat,
    meta: {
        layout: layouts.navLeft,
    },
};
